module.exports = {
  entry: './src/apps/turbonomic-price-estimator/index.tsx',
  shortcode: 'turbonomic-price-estimator',
  title: 'Turbomomic Price Estimator',
  status: 'stable',
  description: 'Allows users to determine a price.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-turbonomic-price-estimator-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'id',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
    org: 'digitalsales', // to filter the widget.
    brand: 'automation', // automation, dataai, security, sustainabilty, storage, other
    widgetLocation: '/pricing', // default '/pricing' but sometimes '/'
    productName: 'turbonomic', // the product name in the URL
    activatedCountryPages: [
      'us-en',
      'cn-zh',
      'br-pt',
      'de-de',
      'es-es',
      'fr-fr',
      'id-id',
      'it-it',
      'jp-ja',
      'kr-ko',
      'mx-es',
    ],
  },
};
